import { QueryFormatFilter, QueryListFilter } from '@hotjar/global-filters';
import { getRelevanceScoreSubQuery } from '../features/RecordingsPage/utils';
import { JsonFilters, HotjarFilters } from '../store/list/types';

/**
 * This is a specific case for the Player domain in the context of the V3 API.
 *
 * We are passing here the hotjar filters, but for the moment we only look for relevance score.
 * The watched filter in the V3 API is not passed as a global filters property.
 */
export const getFiltersMergedWithRelevanceFilter = (
  filters: JsonFilters,
  hotjarFilters: HotjarFilters,
): QueryFormatFilter => {
  const relevanceFilter = getRelevanceScoreSubQuery(hotjarFilters);

  if (!relevanceFilter) {
    return filters;
  }

  if ((filters as QueryListFilter).AND && Array.isArray((filters as QueryListFilter).AND)) {
    return {
      AND: (filters as QueryListFilter)?.AND?.concat([relevanceFilter as QueryListFilter]),
    };
  }

  return {
    AND: [filters, relevanceFilter as QueryFormatFilter],
  };
};
